import { render, staticRenderFns } from "./view.vue?vue&type=template&id=04161cdf"
import script from "./view.vue?vue&type=script&lang=js"
export * from "./view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04161cdf')) {
      api.createRecord('04161cdf', component.options)
    } else {
      api.reload('04161cdf', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=04161cdf", function () {
      api.rerender('04161cdf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/process/view.vue"
export default component.exports